import Modal from "@/atomic/atoms/Modal";
import { Invoice } from "@/hooks/useTicket";

const TicketModal = ({
  toggleModal,
  generatePDF,
  invoice,
}: {
  toggleModal: () => void;
  generatePDF: () => void;
  invoice: Invoice | null;
}) => {
  const tollsPrice = invoice?.debts?.reduce(
    (sum: number, item) => sum + Number(item?.originalPrice.replace(/,/g, '.')),
    0
  );
  const fines = invoice?.debts?.reduce(
    (sum: number, item) => sum + Number(item?.fine.replace(/,/g, '.')),
    0
  );
  return (
    <Modal
      content={<div className="flex flex-col">
        <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-gray-300 rounded-full"></div>
        <button
          type="button"
          onClick={toggleModal}
          className="absolute top-6 right-6 text-black"
        >
          <img src="/svg/icon-close.svg" alt="Close" className="w-6 h-6" />
        </button>
        <div className="overflow-auto max-h-[calc(100vh-300px)] mt-6 mb-3">
          <p className="text-black text-center font-bold text-xl mb-2">Recibo</p>
          <p className="text-black text-center text-base">Seu pagamento de <b>R$ {invoice?.price}</b> foi realizado com sucesso. Confira os detalhes a seguir.</p>
          <p className="text-black font-bold mt-2">Dados da transação {invoice?.invoiceId}</p>
          <div className="w-full mt-1">
            <div className="w-full flex flex-row justify-between">
              <p className="text-black">Data:</p>
              <p className="text-black">{invoice?.invoiceDate}</p>
            </div>
            <div className="w-full flex flex-row justify-between">
              <p className="text-black">Passagens:</p>
              <p className="text-black">R$ {tollsPrice?.toFixed(2)?.replace(/\./g, ',')}</p>
            </div>
            <div className="w-full flex flex-row justify-between">
              <p className="text-black">Multas e juros:</p>
              <p className="text-black">R$ {fines?.toFixed(2)?.replace(/\./g, ',')}</p>
            </div>
            <div className="w-full flex flex-row justify-between">
              <p className="text-black font-bold">Total:</p>
              <p className="text-black font-bold">R$ {invoice?.price}</p>
            </div>
          </div>
          <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
          <p className="text-black font-bold mt-2">Detalhes do pagamento</p>
          {invoice?.debts?.map((debt, index) => (
            <div key={index} className="w-full">
              <div className="w-full mt-1 mb-1">
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black">Placa:</p>
                  <p className="text-black">{debt.plate}</p>
                </div>
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black">Data:</p>
                  <p className="text-black">{debt.date}</p>
                </div>
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black">Concessionária:</p>
                  <p className="text-black">{debt.owner}</p>
                </div>
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black">Passagem:</p>
                  <p className="text-black">R$ {debt.originalPrice}</p>
                </div>
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black">Juros e multas:</p>
                  <p className="text-black">R$ {debt.fine}</p>
                </div>
                <div className="w-full flex flex-row justify-between">
                  <p className="text-black font-bold">Total:</p>
                  <p className="text-black font-bold">R$ {debt.price}</p>
                </div>
              </div>
              <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            </div>
          ))}
        </div>
        <button
          className={`bg-black hover:bg-transparent hover:text-black text-principal border p-2 rounded-lg h-[calc(60px)] w-full`}
          type="button"
          onClick={generatePDF}>
          Baixar recibo
        </button>
      </div>}
    />
  );
};

export default TicketModal;
